import { render, staticRenderFns } from "./thirdAccount.vue?vue&type=template&id=03bf0275&scoped=true&"
import script from "./thirdAccount.vue?vue&type=script&lang=js&"
export * from "./thirdAccount.vue?vue&type=script&lang=js&"
import style0 from "./thirdAccount.vue?vue&type=style&index=0&id=03bf0275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf0275",
  null
  
)

export default component.exports